import { render, staticRenderFns } from "./VersionModal.vue?vue&type=template&id=7c48fc5a"
import script from "./VersionModal.vue?vue&type=script&lang=js"
export * from "./VersionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports